import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const AccessibleText = ({ displayText, accessibleText, className }) => (
  <>
    <span className={className} aria-hidden>
      {displayText}
    </span>
    <span className={styles.accessiblyHidden}>{accessibleText}</span>
  </>
)

AccessibleText.propTypes = {
  displayText: PropTypes.node.isRequired,
  accessibleText: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default AccessibleText
